import React, { useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import LandingPage from "./components/Landing/LandingPage";
import "./index.css";

const EDITOR_PATH = "/editor";

const EditorApp = React.lazy(() => import("./App"));

const normalizePath = (path: string) => path.replace(/\/+$/, "") || "/";

const AppRouter: React.FC = () => {
  const [path, setPath] = useState(() => normalizePath(window.location.pathname));

  useEffect(() => {
    const handlePopState = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigateToEditor = useCallback(() => {
    if (normalizePath(window.location.pathname) !== EDITOR_PATH) {
      window.history.pushState({}, "", EDITOR_PATH);
      setPath(EDITOR_PATH);
    }
  }, []);

  if (path === EDITOR_PATH)
    return (
      <React.Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
        <EditorApp />
      </React.Suspense>
    );
  return <LandingPage onOpenEditor={navigateToEditor} />;
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);
